const newSummary = [
  {
    Name: "Abhishek Thapa",
    date: "2021",
    content:
      "Innovative and deadline-driven Graphic Designer with 3+ years of experience designing and developing user-centered     digital/print marketing material from initial concept to final, polished deliverable.",
    address: "lalitpur, Nepal",
    phone: "+977 9823617508",
    email: "abeeshek10@gmail.com",
  },
];

const newEducation = [
  {
    Name: "Master of Fine Arts & Graphic Design",
    date: "2015-2016",
    institute: "Rochester Institute of Technology, Rochester, NY",
    content:
      "Qui deserunt veniam. Et sed aliquam labore tempore sed quisqua iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti",
  },
  {
    Name: "Bachelor of Fine Arts & Grahic Design",
    date: "2010-2014",
    institute: "Rochester Institute of Technology, Rochester, NY",
    content:
      "Quia nobis sequi est occaecati aut. Repudiandae et iusto quae reiciendis et quis Eius vel ratione eius unde vitae rerum voluptates asperiores voluptatem Earum molestiae consequatur neque etlon sader mart dila",
  },
];

const newProfessional = [
  {
    Name: "Senior graphic design specialist",
    date: "2019 - present",
    location: "Experion, New York, NY",
    exp1: " Lead in the design, development, and implementation of the graphic, layout, and production communication materials",
    exp2: "Delegate tasks to the 7 members of the design team and provide counsel on all aspects of the project.",
    exp3: "Supervise the assessment of all graphic materials in order to ensure quality and accuracy of the design",
  },
  {
    Name: "Graphic design specialist",
    date: "2017 - 2018",
    location: "Stepping Stone Advertising, New York, NY",
    exp1: "Developed numerous marketing programs (logos,brochures,infographics, presentations, and advertisements).",
    exp2: "Managed up to 5 projects or tasks at a given time while under pressure.",
    exp3: "Recommended and consulted with clients on the most appropriate graphic design",
  },
];

export { newSummary };
export { newEducation };
export { newProfessional };
